module.exports = __webpack_public_path__ + "static/media/tgle-technology.ff7decee.svg";